export enum ViewStatus {
  Init,
  Loading,
  Resolved,
  Rejected,
}
